<template>
  <CustomPage title="消息">
    <div slot="content" class="content">
      <div v-html="content" class="detail"></div>
    </div>
  </CustomPage>
</template>

<script>
import Bus from '@/utils/bus'
import CustomPage from '@/components/custom-page'
import { getDetail } from './webApi'
export default {
  components: { CustomPage },
  data() {
    return {
      content: null,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('app/showLoading')
      getDetail(this.$route.query)
        .then((res) => {
          this.$store.dispatch('app/hideLoading')
          this.content = res.data.content

          Bus.$emit('refreshMessageData')
          setTimeout(() => {
            this.$store.dispatch('app/getMessage')
          }, 1000)
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  padding: 22px 24px;
}
</style>
